import { useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import AuthLayout from "../../components/Auth/AuthLayout";
import TextField from "../../components/Auth/TextField";
import SubmitButton from "../../components/Auth/SubmitButton";
import { ForgotPassword } from "../../service/login";

export default function Index() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (email === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El campo correo es obligatorio!",
      });
      return;
    }

    setLoading(true);
    ForgotPassword({ email })
      .then((response) => {
        setLoading(false);
        if (response.success === false) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.message || "No se pudo enviar el correo",
          });
          return;
        }
        setSent(true);
      })
      .catch(() => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se pudo enviar el correo, intenta de nuevo",
        });
      });
  };

  if (sent) {
    return (
      <AuthLayout
        title="Revisa tu correo"
        subtitle="Si esa cuenta existe, ahí está el enlace para crear una contraseña nueva. El enlace vence en una hora."
        footer={
          <Link className="auth-footer-link" to="/login">
            Volver a entrar
          </Link>
        }
      />
    );
  }

  return (
    <AuthLayout
      title="¿Olvidaste tu contraseña?"
      subtitle="Escribe tu correo y te enviamos un enlace para crear una nueva."
      footer={
        <Link className="auth-footer-link" to="/login">
          Volver a entrar
        </Link>
      }
    >
      <form onSubmit={handleSubmit}>
        <TextField
          id="email"
          label="Correo electrónico"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          inputMode="email"
          autoFocus
        />

        <SubmitButton loading={loading} loadingLabel="Enviando...">
          Enviar enlace
        </SubmitButton>
      </form>
    </AuthLayout>
  );
}
